import { useEffect, useCallback } from "react";
import { useParameter, useSubscriptionProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";
import { useSlideSubtitle } from "../hooks/useSlideSubtitle";

import { ApplyParameters } from "../../../shared/components/SubscriptionProvider/SubscriptionProvider.types";

export function useSubscription() {
  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  const {
    actions: { setParameters, setTitle, setSubtitle, setApplyParametersFunction },
  } = useSubscriptionProviderContext();

  const [frequencies, setFrequencies] = useParameter<number>("@frequencies");
  const [commodityDisplay, setCommodityDisplay] = useParameter<number>("@commodities_display");
  const [commodity, setCommodity] = useParameter<number>("@commodities");
  const [units, setUnits] = useParameter<number>("@units");

  const [startDate] = useParameter<number>("@start_date");
  const [endDate] = useParameter<number>("@end_date");
  const [calendar] = useParameter<number>("@calendar");

  useEffect(() => {
    setTitle(title);
    setSubtitle(subtitle);
    setParameters({
      "@calendar": calendar,
      "@commodities": commodity,
      "@commodities_display": commodityDisplay,
      "@units": units,
      "@frequencies": frequencies,
      "@start_date": startDate,
      "@end_date": endDate,
    });
  }, [title, subtitle, calendar, commodity, units, frequencies, startDate, endDate, commodityDisplay, setParameters]);

  const applyParameters = useCallback(
    (parameters: ApplyParameters) => {
      setCommodity((parameters["@commodities"].value as string[]).map(Number)[0]);
      setCommodityDisplay((parameters["@commodities_display"].value as string[]).map(Number)[0]);
      setUnits((parameters["@units"].value as string[]).map(Number)[0]);
      setFrequencies((parameters["@frequencies"].value as string[]).map(Number)[0]);
    },
    [setFrequencies, setCommodity, setCommodityDisplay, setUnits]
  );

  useEffect(() => {
    setApplyParametersFunction(applyParameters);
  }, [setApplyParametersFunction, applyParameters]);
}
